var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"small":"","color":"primary","disabled":_vm.submited},nativeOn:{"click":function($event){return _vm.submitTask($event)}}},[_vm._v("\n  submit "),_c('v-icon',[_vm._v("done")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }